import { StructuredData } from "./StructuredData";
import { generatePageSchemas, type SchemaOptions } from "@/lib/schema";
import { baseMetadata, site } from "@/lib/seo";
import type { Metadata } from "next";

interface PageSchemaProps {
  options: SchemaOptions;
}

export function PageSchema({ options }: PageSchemaProps) {
  const schemas = generatePageSchemas(options);
  return <StructuredData schemas={schemas} />;
}

export function getPageOgImages(options: SchemaOptions, type: "facebook" | "twitter"): string[] {
  const ogImages = options.pageOgImages;

  if (ogImages && ogImages[type]) {
    return Array.isArray(ogImages[type]) ? ogImages[type] : [ogImages[type]];
  }

  return [site.ogImage];
}

// Generate metadata for Next.js App Router
export function generatePageMetadata(options: SchemaOptions): Metadata {
  return baseMetadata({
    title: options.pageName,
    description: options.pageDescription,
    keywords: options.keywords,
    alternates: {
      canonical: options.pageUrl,
    },
    openGraph: {
      title: options.ogTitle ?? options.pageName,
      description: options.ogDescription ?? options.pageDescription,
      url: options.pageUrl,
      type: "website",
      siteName: "PickcelDigitalSignage",
      images: getPageOgImages(options, "facebook").map(image => ({
        url: image,
        width: 1200,
        height: 630,
      })),
      locale: "en_US",
    },
    twitter: {
      card: "summary_large_image",
      site: "@PickcelSignage",
      title: options.twitterTitle ?? options.pageName,
      description: options.twitterDescription ?? options.pageDescription,
      images: getPageOgImages(options, "twitter"),
    },
    other: {
      "fb:app_id": "2471707979511008",
    },
  });
}
